/* SPACEREBELS – "Completa l'arredamento" (PL: Kompletuj wnętrze) – wersja Dawn
   Dodawanie zestawu do koszyka (/cart/add.js) + filtr pomieszczeń.
   - cart_type = drawer  → odświeża i otwiera szufladę koszyka Dawn (<cart-drawer>)
   - cart_type = notification / page → odświeża licznik koszyka (#cart-icon-bubble)
     i pokazuje komunikat z linkiem do koszyka.
   Teksty (EN/IT) przychodzą z Liquid: <script type="application/json" data-sr-promo-strings> (klucze sr_promo.bundles.*).
   Adresy z prefiksem języka: Shopify.routes.root (np. /en/). */
(() => {
  const strings = () => {
    if (window.__srPromoStrings) return window.__srPromoStrings;
    let s = {};
    try { s = JSON.parse(document.querySelector('[data-sr-promo-strings]')?.textContent || '{}'); } catch (e) {}
    return (window.__srPromoStrings = s);
  };

  if (!window.customElements.get('sr-bundle-add')) {
    class SrBundleAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.msg = this.querySelector('[data-msg]');
        this.button?.addEventListener('click', () => this.add());
      }

      setMsg(text, ok, withLink) {
        if (!this.msg) return;
        this.msg.textContent = text || '';
        this.msg.className = 'sr-bundle__msg ' + (text ? (ok ? 'sr-bundle__msg--ok' : 'sr-bundle__msg--err') : '');
        if (text && withLink) {
          const a = document.createElement('a');
          a.href = this.dataset.cartUrl || (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart');
          a.className = 'sr-bundle__cartlink';
          a.textContent = this.dataset.cartLabel || strings().cartLink || '';
          this.msg.append(' ', a);
        }
      }

      sectionHTML(html, selector) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector(selector);
        return el ? el.innerHTML : null;
      }

      async add() {
        let items;
        try { items = JSON.parse(this.dataset.items || '[]'); } catch (e) { items = []; }
        if (!items.length) return;

        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const bundleName = this.dataset.bundle || strings().setFallback || 'Set';
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];

        this.button.setAttribute('aria-busy', 'true');
        this.setMsg('');

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              // _zestaw = ukryty atrybut pozycji (widoczny w zamówieniu w adminie), jak w PL
              items: items.map((i) => ({ id: i.id, quantity: i.qty || 1, properties: { _zestaw: bundleName } })),
              sections: sections.join(','),
              sections_url: window.location.pathname
            })
          });
          const json = await response.json();

          if (!response.ok || json.status) {
            this.setMsg(json.description || json.message || strings().error || 'Error', false);
            return;
          }

          // Dawn: szuflada koszyka (gdy cart_type = drawer)
          if (drawer && typeof drawer.renderContents === 'function' && json.sections && json.sections['cart-drawer']) {
            drawer.classList.remove('is-empty');
            const first = (json.items && json.items[0]) || {};
            drawer.renderContents({ ...first, id: first.product_id || first.id, sections: json.sections });
            this.setMsg(this.dataset.successText || strings().success || '', true, false);
            return;
          }

          // Dawn: notification / page – odśwież licznik w nagłówku
          const bubble = document.getElementById('cart-icon-bubble');
          const bubbleHTML = json.sections && json.sections['cart-icon-bubble'];
          if (bubble && bubbleHTML) {
            const inner = this.sectionHTML(bubbleHTML, '.shopify-section');
            if (inner !== null) bubble.innerHTML = inner;
          }
          // Dawn pub/sub (constants.js + pubsub.js) – inne komponenty mogą nasłuchiwać zmian koszyka
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sr-bundle-add', cartData: json });
            }
          } catch (e) {}
          this.setMsg(this.dataset.successText || strings().success || '', true, true);
        } catch (e) {
          this.setMsg(strings().network || 'Error', false);
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }
    }
    window.customElements.define('sr-bundle-add', SrBundleAdd);
  }

  if (!window.customElements.get('sr-bundle-filter')) {
    class SrBundleFilter extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const chip = e.target.closest('[data-room]');
          if (!chip) return;
          const room = chip.dataset.room;
          this.querySelectorAll('[data-room]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
          const grid = document.getElementById(this.getAttribute('aria-controls'));
          grid?.querySelectorAll('[data-bundle-room]').forEach((card) => {
            const rooms = (card.dataset.bundleRoom || '').split('|');
            card.hidden = room !== '*' && !rooms.includes(room);
          });
        });
      }
    }
    window.customElements.define('sr-bundle-filter', SrBundleFilter);
  }
})();
